import React from 'react';
import { css } from 'linaria';
import {
  AlignBottomIcon,
  AlignBottomSimpleIcon,
  ArchiveIcon,
  ArmchairIcon,
  DoorIcon,
  GridFourIcon,
  HouseLineIcon,
  LightningIcon,
  MagicWandIcon,
  SwatchesIcon,
  ThermometerSimpleIcon,
  TreeStructureIcon,
  TShirtIcon,
} from '@fronton/icons-react';
import { STORAGE_CDN_PATH } from '../../storage-constants';

export type StorageStylesSectionStructure = {
  imgSrc: string;
  modalImgSrc: string;
  name: string;
  nameStyles?: string;
  modalTitle: string;
  descriptionList?: {
    leftIcon: React.ReactNode;
    text: string;
  }[];
};

export const STORAGE_STYLES_CARD_LIST: StorageStylesSectionStructure[] = [
  {
    imgSrc: `${STORAGE_CDN_PATH}/systems/lion-2.jpg/lion-2.jpg`,
    modalImgSrc: `${STORAGE_CDN_PATH}/systems-popup/lion-2.jpg/lion-2.jpg`,
    name: 'styles-section.lion.name',
    modalTitle: 'styles-section.lion.modal-title',
    descriptionList: [
      {
        leftIcon: <TShirtIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.lion.item-first',
      },
      {
        leftIcon: <DoorIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.lion.item-second',
      },
      {
        leftIcon: <SwatchesIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.lion.item-third',
      },
      {
        leftIcon: <ArmchairIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.lion.item-fourth',
      },
      {
        leftIcon: <HouseLineIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.lion.item-fifth',
      },
    ],
  },
  {
    imgSrc: `${STORAGE_CDN_PATH}/systems/metal-2.jpg/metal-2.jpg`,
    modalImgSrc: `${STORAGE_CDN_PATH}/systems-popup/metal-2.jpg/metal-2.jpg`,
    name: 'styles-section.metal.name',
    modalTitle: 'styles-section.metal.name',
    descriptionList: [
      {
        leftIcon: <TShirtIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.metal.item-first',
      },
      {
        leftIcon: <DoorIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.metal.item-second',
      },
      {
        leftIcon: <AlignBottomIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.metal.item-third',
      },
      {
        leftIcon: <ArchiveIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.metal.item-fourth',
      },
      {
        leftIcon: <ThermometerSimpleIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.metal.item-fifth',
      },
    ],
  },
  {
    imgSrc: `${STORAGE_CDN_PATH}/systems/kub-2.jpg/kub-2.jpg`,
    modalImgSrc: `${STORAGE_CDN_PATH}/systems-popup/kub-2.jpg/kub-2.jpg`,
    name: 'styles-section.kub.name',
    modalTitle: 'styles-section.kub.modal-title',
    descriptionList: [
      {
        leftIcon: <MagicWandIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.kub.item-first',
      },
      {
        leftIcon: <TreeStructureIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.kub.item-second',
      },
      {
        leftIcon: <SwatchesIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.kub.item-third',
      },
      {
        leftIcon: <LightningIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.kub.item-fourth',
      },
      {
        leftIcon: <HouseLineIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.kub.item-fifth',
      },
    ],
  },
  {
    imgSrc: `${STORAGE_CDN_PATH}/systems/sliding-doors-2.jpg/sliding-doors-2.jpg`,
    modalImgSrc: `${STORAGE_CDN_PATH}/systems-popup/sliding-doors-2.jpg/sliding-doors-2.jpg`,
    name: 'styles-section.sliding-doors.name',
    nameStyles: css`
      white-space: nowrap;
    `,
    modalTitle: 'styles-section.sliding-doors.name',
    descriptionList: [
      {
        leftIcon: <TreeStructureIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.sliding-doors.item-first',
      },
      {
        leftIcon: <AlignBottomSimpleIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.sliding-doors.item-second',
      },
      {
        leftIcon: <GridFourIcon type="outline" size="m" color="text-primary" />,
        text: 'styles-section.sliding-doors.item-third',
      },
    ],
  },
];
